@if (!contractRecapListError() && contractRecapList().length) {
  <div class="container">
    <div class="side-navbar-position">
      <ml-side-navbar
        class="flex"
        [translationKey]="'application.resume'"
        [title]="'.sidebar-title'"
        [defaultSelectedItem]="defaultSelectedSideBar()"
        [itemList]="sideNavBarItemList()"
        (itemClick)="navigateToRecapCard($event)"
      ></ml-side-navbar>
    </div>
    <div class="recap-container">
      @for (recap of contractRecapList(); track recap.holderName; let index = $index) {
        @if (atLeastOneAttributeHasContent(recap) || recap.title.startsWith('application.recap-card.card-title.resources')) {
          <ml-recap-card-signal #recapCards pvmoComponentTracker [recapInfo]="recap" [recapForm]="resumeForm" id="recap-{{ index }}" tabindex="0"></ml-recap-card-signal>
        }
      }
    </div>
  </div>
} @else if (contractRecapListError()) {
  <p>message moche</p>
} @else {
  <ml-loader />
}
